export enum LoginMechanism {
  Email = 'Email',
  // Google = 'Google' // temporally disabled
  Microsoft = 'Microsoft',
}
